/* eslint-disable import/no-anonymous-default-export */
import { UPDATE_ACTIVE_MODAL, UPDATE_THEME, TOGGLE_APP_DRAWER } from 'store/types';

import { getDefaultTheme } from 'utils/theme-util';

import { saveInLocalStore, getFromLocalStore } from 'utils/state-persistence-util';

const PREFIX = 'commonStates';

const initialState = {
  activeModal: '',
  isAppDrawerOpen: false,
  theme: getFromLocalStore('theme', PREFIX, getDefaultTheme()), // Theme can be integrated with General settings API later.
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_ACTIVE_MODAL:
      return {
        ...state,
        activeModal: action.payload,
      };
    case TOGGLE_APP_DRAWER:
      return {
        ...state,
        isAppDrawerOpen: !state.isAppDrawerOpen,
      };
    case UPDATE_THEME:
      saveInLocalStore('theme', action.payload, PREFIX);
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return state;
  }
}
